import {
    DTOCardFormField,
} from 'app/types/form.types'

import getAbacusSettingsFields from '../BillingCompanyForm/fields/abacusSettings.fields'
import {
    BillingCompany,
} from '../BillingCompanyForm.types'

const getAbacusFields = (
    {
        isSyncedWithAbacusDisabled,
        isNew,
    }: {
        isSyncedWithAbacusDisabled: boolean,
        isNew: boolean,
    },
): DTOCardFormField<keyof BillingCompany>[] => {
    return [getAbacusSettingsFields({
        isNew,
        isSyncedWithAbacusDisabled,
    })]
}

export default getAbacusFields
